export default {
  bugReport: 'Zgłoszenie błędu',
  descriptionPlaceholder: 'Opisz błąd',
  attachments: 'Załączniki',
  sendConfirmation: {
    summary: 'Raport błędu został wysłany',
    detail: 'Otrzymaliśmy zgłoszenie błędu i wkrótce się z Tobą skontaktujemy.',
  },
};
